import React from 'react';
import { useLocation, Route, Switch, Redirect } from 'react-router-dom';
import { Container, Row } from 'reactstrap';

import routes from 'routes.js';
import { ToastContainer } from 'react-toastify';

const Auth = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add('bg-gray');
    return () => {
      document.body.classList.remove('bg-gray');
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/auth') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className='main-content' ref={mainContent}>
        <div className='header bg-gray py-6 py-lg-8'></div>
        {/* Page content */}
        <Container className='pb-5'>
          <Row className='justify-content-center'>
            <Switch>
              {getRoutes(routes)}
              <Redirect from='*' to='/auth/login' />
            </Switch>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
